




































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CKEditor from "ckeditor4-vue";
import { ComponentOptions } from "vue";
import i18n from "../../../locale";
import { PostsApi, PostPostRequest } from "../../../apis";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

declare module "vue/types/options" {
  interface ComponentOptions<V extends Vue> {
    // This adds the `middleware` property to the existing `vue/types/options/ComponentOptions` type
    CKEditor?: string | string[];
  }
}

Vue.use(CKEditor);

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class AddInstruction extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  itemsLanguage = ["English", "Tieng Việt"];
  language = "English";
  headerUrlEn = "";
  headerUrlVn = "";
  subjectEn = "";
  shortDescriptionEn = "";
  contentEn = "";

  subjectVn = "";
  shortDescriptionVn = "";
  contentVn = "";
  errorEdit = "";
  errorMaxLengthSubjectEn = "";
  errorMaxlengthShortDesEn = "";
  errorMaxLengthSubjectVn = "";
  errorMaxlengthShortDesVn = "";
  editorConfig = {
    extraPlugins: "colorbutton,colordialog,font,justify",
  };

  isShow = false;

  get userStore() {
    return this.$store.state.user;
  }

  get instructionStore() {
    return this.userStore.instruction;
  }

  get isFromInstructions() {
    return (
      this.$route.query.previous &&
      this.$route.query.previous === "instructions"
    );
  }

  mounted() {
    if (this.isFromInstructions) {
      this.resetData();
      return;
    }
    this.subjectEn = this.instructionStore.instructionSubjectEn;
    this.headerUrlEn = this.instructionStore.instructionHeaderUrlEn;
    this.headerUrlVn = this.instructionStore.instructionHeaderUrlVn;
    this.shortDescriptionEn =
      this.instructionStore.instructionShortDescriptionEn;
    this.contentEn = this.instructionStore.instructionContentEn;
    this.subjectVn = this.instructionStore.instructionSubjectVn;
    this.shortDescriptionVn =
      this.instructionStore.instructionShortDescriptionVn;
    this.contentVn = this.instructionStore.instructionContentVn;
  }

  getReview() {
    this.userStore.instruction = {
      instructionSubjectEn: this.subjectEn,
      instructionHeaderUrlEn: this.headerUrlEn,
      instructionHeaderUrlVn: this.headerUrlVn,
      instructionShortDescriptionEn: this.shortDescriptionEn,
      instructionContentEn: this.contentEn,
      instructionSubjectVn: this.subjectVn,
      instructionShortDescriptionVn: this.shortDescriptionVn,
      instructionContentVn: this.contentVn,
    };
    this.$router.push({ name: "review-instruction" });
  }

  resetData() {
    this.userStore.instruction = null;
  }

  postPostRequest: PostPostRequest = {} as any;
  async getPublicInstruction() {
    try {
      this.isShow = true;
      this.postPostRequest = {
        subjectEn: this.subjectEn,
        subjectVn: this.subjectVn,
        headerUrlEn: this.headerUrlEn,
        headerUrlVn: this.headerUrlVn,
        contentEn: this.contentEn,
        contentVn: this.contentVn,
        shortDescriptionEn: this.shortDescriptionEn,
        shortDescriptionVn: this.shortDescriptionVn,
        isAbout: false,
      } as PostPostRequest;
      const rs = await new PostsApi().createPost({
        postPostRequest: this.postPostRequest,
      });
    } catch {
    } finally {
      this.resetData();
      this.$router.push({ name: "instructions" });
    }
  }
  doReview() {
    (this as any).$refs.observer.validate().then((success) => {
      if (
        !success ||
        this.contentVn.length == 0 ||
        this.contentEn.length == 0
      ) {
        return;
      }
      this.getReview();
      this.errorEdit = "";
    });

    this.errorEdit = i18n.t("message.empty_content_about").toString();
  }

  doPublicInstruction() {
    (this as any).$refs.observer.validate().then((success) => {
      if (
        !success ||
        this.contentVn.length == 0 ||
        this.contentEn.length == 0
      ) {
        return;
      }
      this.getPublicInstruction();
      this.errorEdit = "";
    });
    this.errorEdit = i18n.t("message.empty_content_about").toString();
  }
}
